import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CheckCircleBrokenIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CheckCircleBrokenIcon(
  props: CheckCircleBrokenIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CheckCircleBrokenIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="24" height="24" rx="4" fill="#EBF2FE" />
      <g clipPath="url(#clip0_23099_16070)">
        <path
          d="M18.6667 11.3904V12.0037C18.6658 13.4413 18.2003 14.8402 17.3395 15.9916C16.4788 17.1431 15.2688 17.9854 13.8902 18.393C12.5116 18.8006 11.0382 18.7517 9.68963 18.2535C8.3411 17.7552 7.18975 16.8345 6.40729 15.6284C5.62482 14.4224 5.25317 12.9958 5.34776 11.5613C5.44235 10.1268 5.99812 8.76129 6.93217 7.66845C7.86621 6.57561 9.1285 5.81399 10.5308 5.49717C11.933 5.18034 13.4002 5.32529 14.7133 5.9104M18.6666 6.66659L12 13.3399L9.99998 11.3399"
          stroke="#4489F9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_23099_16070">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
